import { render, staticRenderFns } from "./badge_modal_new.vue?vue&type=template&id=27e1635b&scoped=true&"
import script from "./badge_modal_new.vue?vue&type=script&lang=js&"
export * from "./badge_modal_new.vue?vue&type=script&lang=js&"
import style0 from "./badge_modal_new.vue?vue&type=style&index=0&id=27e1635b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27e1635b",
  null
  
)

export default component.exports